import { useState } from "react";
import PageLayout from "../PageLayout";

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  // const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const reset = () => {
    setFormData({
      name: "",
      email: "",
      message: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setLoader(true);

    fetch("https://formsubmit.co/ajax/niravjoshi87@gmail.com", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        message: formData.message,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setSubmitted(data.success);
        // setLoader(false);
        reset();
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <>
      <PageLayout>
        <content>
          <section className="py-20">
            <div className="container">
              <div className="flex flex-col">
                <div className="pt-[40px] sm:pt-32" />
                <div className="gap-8">
                  <div className="gap-11">
                    <div className="gap-5">
                      <h2 className="text-[20px] sm:text-[35px]">
                        Contactez-nous
                      </h2>
                      <p className="text-[12px] sm:text-[25px]">
                        <br />
                        Vous avez un projet ou une demande particulière ?
                      </p>
                    </div>
                  </div>
                </div>
                <div className="items-center">
                  <div>
                    <div>
                      <p className="text-secondary/70 text-[12px] sm:text-[25px]">
                        Que vous souhaitiez découvrir nos services de
                        conciergerie standard ou bénéficier de l’excellence de
                        notre offre VIP, remplissez ce formulaire pour recevoir
                        un devis personnalisé ou toutes les informations dont
                        vous avez besoin. Nous vous recontactons dans les plus
                        brefs délais. <br />
                        <br />
                      </p>
                    </div>
                  </div>
                  <div className="w-full">
                    <form
                      onSubmit={handleSubmit}
                      className="flex flex-col gap-5 md:gap-8"
                    >
                      <div>
                        <input
                          required
                          className="w-full border-b border-secondary text-[12px] sm:text-[20px] focus:border-black focus:outline-none pt-3.5"
                          id="name"
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Name"
                        />
                      </div>
                      <div>
                        <input
                          required
                          className="w-full border-b border-secondary text-[12px] sm:text-[20px] focus:border-black focus:outline-none pt-3.5"
                          id="email"
                          type="text"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Email"
                        />
                      </div>
                      <div>
                        <textarea
                          className="w-full border-b border-secondary text-[12px] sm:text-[20px] focus:border-black focus:outline-none py-3.5"
                          id="message"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          placeholder="Tell us about your project"
                          rows={4}
                        />
                      </div>
                      {submitted && (
                        <div className="flex gap-1.5">
                          <div className="bg-primary w-fit p-1 sm:p-1.5 rounded-full flex-shrink-0">
                            <img
                              src="/images/Icon/right-check.png"
                              alt="right-icon"
                            />
                          </div>
                          <p className="text-secondary">
                            Great!!! Email has been Successfully Sent. We will
                            get in touch asap.
                          </p>
                        </div>
                      )}
                      <div className="mt-9">
                        <style>{`
                          .neumorphic-liquid {
                            position: relative;
                            display: inline-block;
                            overflow: hidden;
                            padding: 0.7em 1.7em;
                            font-weight: 400;
                            color: #090909;
                            background: white;
                            border: 1px solid black;
                            border-radius: 0.5em;
                            cursor: pointer;
                            transition: all 0.2s ease-in;
                            z-index: 1;
                            text-transform: uppercase;
                            font-family: Jost;
                          }

                          .neumorphic-liquid::before {
                            content: "";
                            position: absolute;
                            left: 50%;
                            top: 100%;
                            width: 140%;
                            height: 180%;
                            background-color: rgba(0, 0, 0, 0.05);
                            border-radius: 50%;
                            transform: translateX(-50%) scaleY(1) scaleX(1.25);
                            transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
                            z-index: -1;
                          }

                          .neumorphic-liquid::after {
                            content: "";
                            position: absolute;
                            left: 55%;
                            top: 180%;
                            width: 160%;
                            height: 190%;
                            background-color: #ad3500;
                            border-radius: 50%;
                            transform: translateX(-50%) scaleY(1) scaleX(1.45);
                            transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
                            z-index: -1;
                          }

                          .neumorphic-liquid:hover {
                            color: #ffffff;
                            border: 1px solid #ad3500;
                          }

                          .neumorphic-liquid:hover::before {
                            top: -35%;
                            background-color: #ad3500;
                            transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
                          }

                          .neumorphic-liquid:hover::after {
                            top: -45%;
                            background-color: #ad3500;
                            transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
                          }

                          .neumorphic-liquid:active {
                            color: #666;
                            box-shadow: inset 4px 4px 12px #c5c5c5,
                              inset -4px -4px 12px #ffffff;
                          }
                        `}</style>
                        <a className="neumorphic-liquid tracking-[2px] text-[12px] sm:text-[15px]">
                          <span>Envoyer</span>
                        </a>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </content>
      </PageLayout>
    </>
  );
};

export default Contact;
